import type { Timestamp } from '@bufbuild/protobuf/wkt'
import { timestampDate, timestampFromDate } from '@bufbuild/protobuf/wkt'
import { CalendarIcon } from 'lucide-react'

import { useUpdateAssessmentDueDate } from '@/api/assessments.hook'

import { MILLISECONDS_IN_A_DAY } from '@/lib/date/date'

import { DatePicker } from '@/components/lemmala-design-system/date-picker/date-picker'

type AssessmentDueDatePickerProps = {
  assessmentId: string
  dueDate?: Timestamp
  readonly?: boolean
  onDatePickerOpen?: () => void
  onDateSelected?: (date: Date) => void
}

export const AssessmentDueDatePicker = ({
  assessmentId,
  dueDate,
  readonly,
  onDatePickerOpen,
  onDateSelected,
}: AssessmentDueDatePickerProps) => {
  const { mutateAsync: updateAssessmentDueDate } = useUpdateAssessmentDueDate()

  return (
    <DatePicker
      variant='button'
      disabled={readonly}
      // Disable past dates while keeping today selectable (subtract one day so today's midnight is not excluded)
      disabledDates={(date) => date < new Date(Date.now() - MILLISECONDS_IN_A_DAY)}
      onClear={() =>
        updateAssessmentDueDate({
          assessmentId,
          dueDate: undefined,
        })
      }
      value={dueDate ? timestampDate(dueDate) : undefined}
      onOpen={onDatePickerOpen}
      onChange={(date) => {
        if (date) onDateSelected?.(date)
        return updateAssessmentDueDate({
          assessmentId,
          dueDate: date ? timestampFromDate(date) : undefined,
        })
      }}
      emptyStateText='Pick a due date'
      emptyStateIcon={<CalendarIcon className='size-3.5' />}
    />
  )
}
